/**
 * Formats a phone number with spaces e.g. +61343100135 -> +613 4310 0135
 * @param {string | number} phoneNumber The phone number to be formatted, it can be a string or a number
 * @returns {string} the formatted phone number
 */
export default function (phoneNumber) {
    let countryCode = phoneNumber.substring(0,4);
    let phoneNumberStr = phoneNumber.replace(countryCode, '').match(/.{1,4}/g);;

    return countryCode + ' ' + phoneNumberStr.join(' ');
}
